import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-section py-5">
      <div className="container">
        <div className="row">
          {/* Company Information */}
          <div className="col-lg-4 col-md-6">
            <motion.div
              className="footer-box"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}>
              <h4 className="footer-title text-dark">Get in Touch</h4>
              <p className="footer-text">
                At MAD Advisors, we don’t just help you choose a university — we
                help you build your future. Contact us today to start your
                journey towards success.
              </p>
            </motion.div>
          </div>

          {/* Office Locations */}
          <div className="col-lg-4 col-md-6">
            <motion.div
              className="footer-box"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}>
              <h4 className="footer-title text-dark">Our Offices</h4>
              <ul className="list-unstyled">
                <li>
                  <strong>Jaipur (Head Office)</strong>
                  <br />
                  Address: 3/32,Jawahar Nagar,Jaipur,Rajasthan
                  <br />
                  Phone: +91 8112 259 120
                  <br />
                  Email: info@madadvisors.in
                </li>
              </ul>
            </motion.div>
          </div>

          {/* Social Media */}
          <div className="col-lg-4 col-md-12 text-center">
            <motion.div
              className="footer-box"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ once: true }}>
              <h4 className="footer-title">Follow Us</h4>
              <div className="social-icons">
                <Link to="/" className="social-icon">
                  <i className="fab fa-facebook"></i>
                </Link>
                <Link to="/" className="social-icon">
                  <i className="fab fa-twitter"></i>
                </Link>
                <Link to="/" className="social-icon">
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link to="/" className="social-icon">
                  <i className="fab fa-linkedin"></i>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom text-center py-3">
        <p className="mb-0">
          &copy; {new Date().getFullYear()} MAD Advisors. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
